/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.neRecrutePas.ts
 *
 * Messages de la case « ne recrute pas » (migration V131, 2026-09-30) :
 * la case elle-même dans la page Exposants du back-office, son effet dans
 * « Ma fiche » (section des postes facultative) et son badge dans l'écran
 * de relance « fiche incomplète ». Fusionné dans fr.ts, contrôlé par
 * fr.subcatalogs.test.ts. Aucun tiret cadratin, apostrophes typographiques.
 *
 * Mikael - chef de projet - 2026-09-30
 */
export const messagesNeRecrutePasFr: Record<string, string> = {
  // ── Back-office, page Exposants ────────────────────────────────────────
  'neRecrutePas.admin.case': 'Ne recrute pas',
  'neRecrutePas.admin.caseLibelle': 'Ne recrute pas : {nom}',
  'neRecrutePas.admin.aide':
    'Cochée par l’organisation : la fiche se publie sans poste, et aucune relance ne réclame d’offre à cette structure.',
  'neRecrutePas.admin.badge': 'Ne recrute pas',
  'neRecrutePas.admin.enregistre.oui': '{nom} : noté « ne recrute pas ».',
  'neRecrutePas.admin.enregistre.non': '{nom} : de nouveau concerné par les offres.',
  'neRecrutePas.admin.erreur': 'Impossible d’enregistrer la case « ne recrute pas ».',

  // ── Ma fiche (exposant) ────────────────────────────────────────────────
  'neRecrutePas.maFiche.chip': 'Facultatif',
  'neRecrutePas.maFiche.intro':
    'L’organisation a noté que votre structure ne recrute pas : cette section est facultative, votre fiche se publie sans poste.',
  'neRecrutePas.maFiche.jumpToJobs':
    'Cette rubrique présente votre offre en général. Si vous proposez tout de même des postes, ils se saisissent plus bas, dans <lien>Postes à pourvoir</lien> (facultatif).',

  // ── Relance « fiche incomplète » ───────────────────────────────────────
  'neRecrutePas.relance.badge': 'Ne recrute pas : aucune offre réclamée',
};
